export { default } from './BlogPost';
